module.exports = __webpack_public_path__ + "static/media/intro_role.4827a801.png";